import { render, staticRenderFns } from "./AddSelectFieldPopup.vue?vue&type=template&id=f2f893e8"
import script from "./AddSelectFieldPopup.vue?vue&type=script&lang=js"
export * from "./AddSelectFieldPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports